import axiosInstance from './axiosInstance';
import { Content } from '../types';

export async function getContents(q?: string, categoryId?: number | null, topicAreaId?: number | null, tag?: string | null): Promise<Content[]> {
  const params: any = {};
  if (q) params.q = q;
  if (categoryId) params.main_category1_id = categoryId;
  if (topicAreaId) params.topic_area_id = topicAreaId;
  if (tag) params.tag = tag;
  const res = await axiosInstance.get('/api/contents', { params });
  return res.data;
} 